import axios from "axios";

const validContentType = [
  "application/octet-stream",
  "application/zip",
  "application/vnd.android.package-archive",
  "application/x-msdownload",
];

/**
 * @private
 * @param {string} url
 * @return {Promise<boolean>}
 */
async function isUrlDownloadable(url) {
  if (typeof url !== "string" || url === "") {
    return false;
  }
  try {
    // const response = await axios.get(url, { responseType: "stream" });
    const response = await axios.head(url, { responseType: "stream" });

    const contentType = response.headers["content-type"] || "";
    if (!validContentType.includes(contentType)) {
      console.log(`Unexpected content type: ${contentType}`);
      return false;
    }
    return true;
  } catch (e) {
    console.log("isUrlDownloadable " + e);
    return false;
  }
}
/**
 * @static
 * @param {string} url
 */
export function excuteDownload(url) {
  if (typeof url !== "string" || url === "") {
    return;
  }
  console.log("create a tag to download");
  const links = document.createElement("a");
  links.href = url;
  document.body.appendChild(links);
  links.click();
  document.body.removeChild(links);
  return true;
}

/**
 * 接收傳入連結，先確認連結可以下載
 * @static
 * @param {Array | String} url or url array
 */
export const handleDownloadProcess = async (list) => {
  let urls = [];
  if (typeof list === "string" && list !== "") {
    urls.push(list);
  } else if (Array.isArray(list)) {
    urls = list;
  } else {
    return new Error("传入参数错误");
  }
  try {
    let url;
    for (const currentUrl of urls) {
      console.log("currentUrl: " + currentUrl);
      const result = await isUrlDownloadable(currentUrl);
      if (result) {
        url = currentUrl;
        break;
      }
    }
    if (typeof url === "string") {
      excuteDownload(url);
      return true;
    } else {
      throw new Error("无可下载链结");
    }
  } catch (e) {
    throw new Error("下载发生错误" + e);
  }
};

/**
 * 查找第一个可下载的链接
 * @param {string[]} urls 备选下载链接数组
 * @param {object} [options] 配置选项
 * @param {number} [options.timeout=3000] 单个请求超时时间(ms)
 * @param {string} [options.method='HEAD'] 使用的HTTP方法
 * @returns {Promise<string>} 返回第一个可用的下载链接
 */
export async function findFirstAvailableUrl(urls, options = {}) {
  const { timeout = 3000, method = 'HEAD' } = options;
  
  if (!urls || urls.length === 0) {
    throw new Error('至少需要提供一个下载链接');
  }

  // 并行检查所有链接
  const checks = urls.map(url => checkUrlAvailability(url, { timeout, method }));
  
  // 等待第一个成功的检查
  try {
    const firstValid = await Promise.any(checks);
    return firstValid;
  } catch (error) {
    throw new Error('所有链接均不可用');
  }
}

/**
 * 检查单个URL是否可用
 */
async function checkUrlAvailability(url, { timeout, method }) {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    
    const response = await fetch(url, {
      method,
      signal: controller.signal,
      // 添加一些常用headers
      headers: {
        'Range': 'bytes=0-1023', // 只请求少量数据
        // 'Cache-Control': 'no-cache'
      }
    });
    
    clearTimeout(timeoutId);
    
    if (response.ok) {
      return url;
    }
    throw new Error(`HTTP状态: ${response.status}`);
  } catch (error) {
    throw new Error(`URL不可用 (${url}): ${error.message}`);
  }
}
